export default __webpack_public_path__ + "static/media/wookai-2.644d64c5.gif";